import { api } from './client'

export type CalEventType = 'meeting' | 'focus' | 'due' | 'milestone'

export type CalEvent = {
  id: number
  project_id: number | null
  type: CalEventType
  ref_type: 'story' | 'sprint' | 'milestone' | null
  ref_id: number | null
  title: string
  start_at: string  // 'YYYY-MM-DD HH:MM:SS'
  end_at: string | null
  all_day: boolean
  owner_id: number | null
  color: string | null
  created_at: string
  updated_at: string
  /** Null for a personal (projectless) event. */
  project_key: string | null
  project_name: string | null
  project_color: string | null
}

/** Without project_id: the personal calendar (all my projects + my personal events). */
export async function listCalEvents(params: {
  project_id?: number
  owner_id?: number
  from?: string
  to?: string
  type?: CalEventType
}): Promise<CalEvent[]> {
  return api<CalEvent[]>('/cal-events', { query: params })
}

export type CreateCalEvent = {
  type: CalEventType
  title: string
  start_at: string
  end_at?: string | null
  project_id?: number | null
  owner_id?: number | null
  ref_type?: 'story' | 'sprint' | 'milestone' | null
  ref_id?: number | null
  all_day?: number
  color?: string | null
}

export async function createCalEvent(data: CreateCalEvent): Promise<CalEvent> {
  return api<CalEvent>('/cal-events', { method: 'POST', body: data })
}

export async function updateCalEvent(id: number, patch: Partial<CreateCalEvent>): Promise<CalEvent> {
  return api<CalEvent>(`/cal-events/${id}`, { method: 'PATCH', body: patch })
}

export async function deleteCalEvent(id: number): Promise<void> {
  return api<void>(`/cal-events/${id}`, { method: 'DELETE' })
}
